/**
 * メンテナンス中はtrueにする。そうすることですべてのページにアクセスした際に、CustomErrorPageコンポーネントでシステムメンテナンス中の旨が表示される
 */
export const UNDER_MAINTENANCE = false
